<template>
<v-dialog persistent v-model="show" width="500">
  <v-card>
    <v-card-title>
      <span class="headline">コメント編集</span>
    </v-card-title>
    <v-card-actions>
      <v-btn :disabled="!valid" @click="save()">保存</v-btn>
      <v-btn @click="back()">{{ $t('app.buttons.back') }}</v-btn>
    </v-card-actions>
    <v-form ref="form" v-model="valid">
      <v-container fluid>
        <v-layout row wrap>
          <v-flex xs12>
            <remote-autocomplete disabled label="納入指示者" url="employees/kv" v-model="shipment.remarkUser"></remote-autocomplete>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field :rules="[v => !!v && v.length <= 255 || 'less than 255']" clearable label="コメント" v-model="shipment.remark"></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      valid: false,
      shipment: {},
    }
  },
  methods: {
    popup(shipment) {
      this.show = true
      this.shipment = shipment
    },
    save() {
      this.$http.put(`/delivery-orders/${this.shipment.id || this.shipment.shipmentId}/update-remark`, {
        remark: this.shipment.remark
      }).then(()=>{
        this.$message('','SUCCESS')
        this.refreshData()
      })
    },
    refreshData() {
      this.show = false
      this.shipment = {}
      this.$emit('load')
    },
    back(){
      this.refreshData()
    }
  },
  computed: {},
  watch: {},
}
</script>

<style>
</style>
